import { ActivityIndicator, StyleSheet, View } from '@/ui';
import { tokens } from '@/theme/tokens';

/**
 * Full-screen loading state shown while the session is being restored. Always dark
 * (immersive brand surface) regardless of the user's theme preference — it renders
 * before the settings store has hydrated, so it can't read a preference yet anyway.
 */
export function Splash() {
  return (
    <View style={[styles.fill, { backgroundColor: tokens.dark.appBg }]}>
      <ActivityIndicator size="large" color={tokens.accentMint} />
    </View>
  );
}

const styles = StyleSheet.create({
  fill: { flex: 1, alignItems: 'center', justifyContent: 'center' },
});
